<script lang="ts">
  import { storyblokEditable } from '@storyblok/svelte';
  import { ImageCard, type ImageCardProps } from '@stickerapp-org/athena/Card';
  import type { Color } from '@athena-lib/colors';
  import type { ImageCardBlock } from '@storyblok-types';
  import { getUrlByLinkType, calculateFocalPoint } from '$lib/utilities/storyblok';

  const { blok, ...otherProps }: { blok: ImageCardBlock; labelColor?: Color; rounded?: boolean } =
    $props();
  let imageCardProps: ImageCardProps = $derived({
    link: getUrlByLinkType(blok.linkUrl),
    backgroundMedia: {
      url: blok.backgroundImage?.filename ?? '',
      alt: blok.backgroundImage?.alt ?? '',
      focalPoint: blok.backgroundImage ? calculateFocalPoint(blok.backgroundImage) : undefined,
    },
    label: blok.label,
    title: blok.title ?? '',
    titleHeadingTag: blok.titleHeadingTag,
    description: blok.description,
    textColor: blok.textColor,
    innerShadow: blok.noGradient !== true,
    ...otherProps,
  });
</script>

<ImageCard action={storyblokEditable} actionArg={blok} {...imageCardProps} />
